import axios from "axios";

const BASE_URL = process.env.REACT_APP_SERVER;

const endpoints = {
  defaultUser: "/api/v1/org",
  create: "/create",
  update: "/update",
  getCustomerByRef: "/getCustomerByRef",
  login: "/login",
  register: "/register",
  firstLoginFields: "/firstLoginFields",
  logout: "/logout",
};

export async function sendEmail(values) {
  const requestUrl = BASE_URL + endpoints.defaultUser + "/send_email";

  var config = {
    method: "post",
    url: requestUrl,
    headers: {
      "x-api-key": process.env.REACT_APP_OOVAL_API_KEY,
    },
    data: {
      from: values.from,
      to: values.to,
      subject: values.subject,
      message: values.message,
    },
  };

  try {
    const response = await axios(config);

    return response;
  } catch (err) {
    return { error: err.response.data };
  }
}

export async function createOrg(values) {
  try {
    const requestUrl = BASE_URL + endpoints.defaultUser + endpoints.create;

    var config = {
      method: "post",
      url: requestUrl,
      headers: {
        "x-api-key": process.env.REACT_APP_OOVAL_API_KEY,
      },
      data: {
        email: values.email,
        company_name: values.companyName,
        logo: values.logo,
        website: values.website,
        contact_person: values.contactPerson,
      },
    };

    const response = await axios(config);

    return response;
  } catch (err) {
    return { error: err.response.data };
  }
}

export async function updateOrg(values, organization_id) {
  try {
    const requestUrl = BASE_URL + endpoints.defaultUser + endpoints.update;

    var config = {
      method: "patch",
      url: requestUrl,
      headers: {
        "x-api-key": process.env.REACT_APP_OOVAL_API_KEY,
      },
      data: {
        ...values,
        _id: organization_id,
      },
    };

    const response = await axios(config);

    return response;
  } catch (err) {
    console.log("err: ", err);
    return { error: err.response.data };
  }
}

export async function getOrgByEmail(email) {
  const requestUrl =
    BASE_URL +
    endpoints.defaultUser +
    "?org_identifier=" +
    encodeURIComponent(email);

  var config = {
    method: "get",
    url: requestUrl,
    headers: {
      "x-api-key": process.env.REACT_APP_OOVAL_API_KEY,
    },
  };

  const response = await axios(config);

  return response;
}

export function loginUser(values) {
  const requestUrl = BASE_URL + endpoints.defaultUser + endpoints.login;

  var config = {
    method: "post",
    url: requestUrl,
    headers: {
      "x-api-key": process.env.REACT_APP_OOVAL_API_KEY,
    },
    data: {
      email: values.email,
      password: values.password,
    },
  };

  return axios(config);
}

export function registerUser(values) {
  const requestUrl = BASE_URL + endpoints.defaultUser + endpoints.register;

  var config = {
    method: "post",
    url: requestUrl,
    headers: {
      "x-api-key": process.env.REACT_APP_OOVAL_API_KEY,
    },
    data: {
      name: values.userName,
      email: values.email,
      password: values.password,
    },
  };

  return axios(config);
}

export function firstLogin(values, userID, userEmail) {
  const requestUrl =
    BASE_URL + endpoints.defaultUser + endpoints.firstLoginFields;

  const token = window.localStorage.getItem("token");

  var config = {
    method: "post",
    url: requestUrl,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-api-key": process.env.REACT_APP_OOVAL_API_KEY,
    },
    data: {
      userID: userID,
      contact_person: values.personOfContact,
      phone_number: values.phoneNumber,
      company_name: values.companyName,
      company_country: values.companyCountry,
      company_city: values.companyCity,
      company_address: values.companyAddress,
      event_type: values.eventType,
    },
  };

  return axios(config);
}

export function getCustomerByRef(ref) {
  const requestUrl =
    BASE_URL + endpoints.defaultUser + endpoints.getCustomerByRef + "/" + ref;
  const token = window.localStorage.getItem("token");

  return axios({
    method: "get",
    url: requestUrl,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-api-key": process.env.REACT_APP_OOVAL_API_KEY,
    },
  });
}

export function logoutUser() {
  const requestUrl = BASE_URL + endpoints.defaultUser + endpoints.logout;
  const token = window.localStorage.getItem("token");

  return axios({
    method: "post",
    url: requestUrl,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-api-key": process.env.REACT_APP_OOVAL_API_KEY,
    },
  });
}

export function addTicketsToDB() {}
